export default __webpack_public_path__ + "static/media/PinchActive.b1a4ec7c.svg";